import React, { useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash/debounce';

import {
    Input,
    Radio,
} from 'antd';

import * as T from 'utils/types';
import searchBlockS from "./SearchBlockSlice";
import searchPgUserInputsS from 'features/content/search_page/UserInputsSlice';
import SearchSyntaxHint from "./SearchSyntaxHint";

const { Search } = Input;


//GsPubSearchBlock
export default () => {
    const dispatch = useDispatch();
    const {
        searchInput_internal,
    } = useSelector((state: T.RootState) => state.searchBlock);
    const {
        keywordType,
    } = useSelector((state: T.RootState) => state.searchPgUserInputs);

    const setSearchInput_debounced = useMemo(() =>
        debounce((value) => {
            dispatch(searchPgUserInputsS.actions.setSearchInput(value))
        }, 1000)
        , [dispatch]);
    const setInputSearch_debounced100ms = useMemo(() =>
        debounce((value) => {
            dispatch(searchPgUserInputsS.actions.setSearchInput(value))
        }, 100)
        , [dispatch]);

    return <>
        <Input.Group>
            <Search
                onChange={(event) => {
                    dispatch(searchBlockS.actions.setSearchInput_internal(event.target.value));
                    setSearchInput_debounced(event.target.value);
                }}
                value={searchInput_internal}
                placeholder={keywordType === 'search' ?
                    "Search by keyword" :
                    "Search by researcher name"
                }
                onSearch={value => setInputSearch_debounced100ms(value)}
                allowClear
            />
            {keywordType === "search" && <SearchSyntaxHint />}
        </Input.Group>

        <Radio.Group
            buttonStyle="solid"
            value={keywordType}
            style={{ margin: '8px 0 8px 14px' }}
            onChange={(event) => {
                dispatch(searchBlockS.actions.setSearchInput_internal(''));
                dispatch(searchPgUserInputsS.actions.setSearchInput(''));
                dispatch(searchPgUserInputsS.actions.setKeywordType(event.target.value as T.keywordType));
            }}>
            <Radio value="search">Keyword</Radio>
            <Radio value="match">Researcher</Radio>
        </Radio.Group>

    </>
}